import { RESPONSE_STATUS_CODE } from "../constants/constant";
import { properties } from "../util/Properties";


export const getService = async (url) => {
  try {
    let data = await fetch(`${properties.cdnURL}${url}`, {
      async: true,
      crossDomain: true,
      method: "GET",
      headers: {
        Pragma: "no-cache",
        "cache-control": "no-cache",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    if (RESPONSE_STATUS_CODE.STATUS_200 === data.status) {
      data = await data.json();
      return data;
    } else {
      return data.json();
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postService = async (url, requestBody) => {
  try {
    let data = await fetch(`${properties.cdnURL}${url}`, {
      async: true,
      crossDomain: true,
      method: "POST",
      headers: {
        Pragma: "no-cache",
        "cache-control": "no-cache",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(requestBody),
    });
    data = await data.json();
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
